var React = require('react');

function IconBrowser (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm384 0c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24z"}));
}

IconBrowser.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = IconBrowser;

IconBrowser.default = IconBrowser;
